/**
 * Deterministic avatar background color picker.
 *
 * Hashes the seed (typically the user's full name) and selects a color from
 * a curated palette that complements the Reli Exchange brand theme
 * (primary #0033ff / secondary #8D98C2). The same input always returns the
 * same color, while a small palette keeps the UI cohesive.
 */
export const AVATAR_PALETTE = [
  "#0033ff", // primary main
  "#0066ff", // primary light
  "#3B5BDB", // indigo
  "#4263EB", // royal blue
  "#5C6AC4", // muted indigo
  "#7048E8", // violet
  "#1864AB", // deep blue
  "#1098AD", // teal
  "#0CA678", // green
  "#E8590C", // burnt orange
  "#D6336C", // raspberry
  "#5563A0", // slate blue
] as const;

const hashString = (input: string): number => {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    // djb2-ish; sufficient for palette indexing
    hash = (hash * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

export const getAvatarColor = (seed?: string | null): string => {
  const normalized = (seed ?? "").trim().toLowerCase();
  if (!normalized) {
    return AVATAR_PALETTE[0];
  }
  return AVATAR_PALETTE[hashString(normalized) % AVATAR_PALETTE.length];
};

export default getAvatarColor;
